import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCarousel from 'vue-carousel'

import AOS from 'aos'
import {v4 as uuidv4} from 'uuid'
import SugarcoatSdk from './sdk/index.js'

import './scss/main.scss'

Vue.config.productionTip = false

Vue.use(VueCarousel)

const sdk = new SugarcoatSdk('https://api.sugar-coat.io/v1/', process.env.VUE_APP_API_KEY);

Vue.prototype.$api = sdk;

new Vue({
  router,
  el: '#app',
  data: {
    // Uh oh - appName is *also* the name of the
    // instance property we defined!
    store: {
      contact_email: 'sales@vintriguewines.com',
      telephone_number: '+44(0)1207 521234'
    },
    basket: null
  },
  methods: {
    setBasket: function (basket) {
      this.basket = basket;
    },
    formatProductPrice: function (product) {
      let value = '';
      switch (true) {
        case product.price < 5:
          value = '£';
          break;
        case product.price >= 5 && product.price < 7:
          value =  '££';
          break;
        case product.price >= 7 && product.price < 9:
          value =  '£££';
          break;
        case product.price >= 9 && product.price < 15:
          value =  '£££';
          break;
        default:
          value =  '£££££'
      }

      return value;
    },
    isProductInBasket: function (productId) {
      if (this.basket) {
        for (var i = 0; i < this.basket.products.length; i++) {
          if (this.basket.products[i].product.id === productId) {
            return true;
          }
        }
      }
      return false;
    },
    loadBasket: function () {
      this.$root.$api.getBasketById(this.getBasketKey())
          .then(response => {
            if (response.data != null) {
              this.basket = response.data.basket;
            }
          }).catch(error => {
        console.log(error);
      })
    },
    getBasketKey: function () {
      return localStorage.getItem('basketKey');
    },
    addProductToBasket: function (productId) {
      this.$root.$api.addProductToBasket(this.$root.getBasketKey(), productId)
          .then(response => {
            if (response.data != null) {
              this.$root.setBasket(response.data.basket);
            }
          }).catch(error => {
        console.log(error);
      })
    },
    removeProductFromBasket: function (productId) {
      this.$root.$api.removeProductFromBasket(this.$root.getBasketKey(), productId)
          .then(response => {
            if (response.data != null) {
              this.$root.setBasket(response.data.basket);
            }
          }).catch(error => {
        console.log(error);
      })
    },
    sortByProperty: function (object, property) {
      const sorted = object.sort(function(a, b){
        // Use toUpperCase() to ignore character casing
        const optionA = a[property].toUpperCase();
        const optionB = b[property].toUpperCase();

        let comparison = 0;
        if (optionA > optionB) {
          comparison = 1;
        } else if (optionA < optionB) {
          comparison = -1;
        }
        return comparison;
      })

      return sorted;
    },
  },
  mounted: function () {

  },
  created: function () {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out-sine',
      once: true,
      offset: 60,
    });

    if (localStorage.getItem("basketKey") === null) {
      localStorage.setItem('basketKey', uuidv4());
    }
    this.loadBasket();
  },
  render: h => h(App)
})